const TermsData = [
  {
    id: "acceptance",
    title: "Acceptance of Terms",
    content: [
      "Welcome to KodeVedic, a digital learning platform operated by JoinSPAF, a registered NGO based in Gondia, Maharashtra, India. By accessing or using the Platform, you confirm that you are at least 13 years of age and that you have read, understood, and agree to be bound by these Terms of Service.",
      "If you are using the Platform on behalf of an organisation, you represent that you have authority to bind that organisation to these Terms.",
      "We reserve the right to update these Terms at any time. Continued use of the Platform after changes are posted constitutes acceptance of the revised Terms.",
    ],
  },
  {
    id: "account-registration",
    title: "Account Registration",
    content: [
      "You must create an account to access most features of KodeVedic, including enrolling in courses and tracking your progress.",
      "You agree to provide accurate, current, and complete information during registration, and to keep your account information updated.",
      "You are responsible for maintaining the confidentiality of your password and for all activity that occurs under your account. You must notify us immediately at connect@kodevedic.com if you suspect unauthorised access to your account.",
      "You may not transfer, sell, or share your account with another person. Each account is for a single individual's personal use only.",
    ],
  },
  {
    id: "course-enrollment",
    title: "Course Enrolment and Access",
    content: [
      "Upon successful payment for a course, you receive a non-exclusive, non-transferable licence to access and view that course content for personal, non-commercial, educational purposes.",
      "Lifetime Access: Once enrolled, you retain access to the course for the duration the course remains on the Platform, plus an additional 180-day access guarantee. Access may be revoked only in cases of violation of these Terms.",
      "You may not download, copy, redistribute, transmit, display, or create derivative works from course content without prior written permission from KodeVedic or the course instructor.",
      "Free previews or trial sections, where offered, are provided 'as-is' and do not guarantee the same access rights as paid enrolment.",
    ],
  },
  {
    id: "payments-refunds",
    title: "Payments and Refunds",
    content: [
      "All course prices are listed in Indian Rupees (INR) inclusive of applicable taxes. Prices are subject to change; however, your enrolled courses will not be repriced after purchase.",
      "Payments are processed securely via Razorpay. KodeVedic does not store your card details.",
      "30-Day Refund Policy: If you are not satisfied with a course, you may request a full refund within 30 days of purchase, provided you have not completed more than 30% of the course content. Refund requests must be submitted to connect@kodevedic.com with your order ID.",
      "Refunds will be processed to the original payment method within 7–10 business days, subject to Razorpay and banking processing times.",
      "Promotional or discounted courses may have different refund terms specified at the time of purchase.",
    ],
  },
  {
    id: "user-conduct",
    title: "User Conduct",
    content: [
      "You agree to use the Platform only for lawful purposes and in a manner consistent with all applicable laws and regulations.",
      "You must not: share your account credentials or allow others to use your account to access paid content; upload, post, or transmit any content that is harmful, abusive, defamatory, obscene, or violates any third party's intellectual property rights; attempt to reverse-engineer, scrape, or systematically download Platform content; use automated tools (bots, spiders) to access or index the Platform without our written consent.",
      "Violations of this section may result in immediate suspension or termination of your account without refund.",
    ],
  },
  {
    id: "instructor-terms",
    title: "Instructor Terms",
    content: [
      "If you publish a course on KodeVedic as an instructor, you represent and warrant that you own or have the right to use all content you upload, including video, audio, text, images, and supplementary materials.",
      "You grant KodeVedic a non-exclusive, worldwide, royalty-free licence to host, display, market, and distribute your course content on the Platform for the purpose of fulfilling student enrolments.",
      "KodeVedic reserves the right to remove any course that violates our content standards, these Terms, or applicable law, with or without prior notice.",
      "Revenue sharing and payment terms for instructors are governed by a separate Instructor Agreement provided upon acceptance as an instructor on the Platform.",
    ],
  },
  {
    id: "intellectual-property",
    title: "Intellectual Property",
    content: [
      "The KodeVedic brand, logo, website design, software, and all Platform-level content (excluding instructor-uploaded course content) are the intellectual property of JoinSPAF / KodeVedic and are protected under applicable Indian and international intellectual property laws.",
      "Course content uploaded by instructors remains the intellectual property of the respective instructors, subject to the licence granted to KodeVedic under the Instructor Terms.",
      "Student-generated content (e.g., forum posts, assignment submissions) is owned by the student but grants KodeVedic a licence to display it within the Platform context.",
      "Any unauthorised use of our intellectual property may result in legal action.",
    ],
  },
  {
    id: "disclaimer",
    title: "Disclaimer and Limitation of Liability",
    content: [
      "The Platform and its content are provided 'as is' and 'as available' without warranties of any kind, express or implied. KodeVedic does not guarantee that courses will result in employment, certification from external bodies, or any specific career outcome.",
      "To the maximum extent permitted by applicable law, KodeVedic and JoinSPAF shall not be liable for any indirect, incidental, special, or consequential damages arising out of your use of the Platform, including loss of data, revenue, or business opportunities.",
      "Our total liability to you for any claim arising from use of the Platform shall not exceed the total fees paid by you to KodeVedic in the 12 months preceding the claim.",
    ],
  },
  {
    id: "governing-law",
    title: "Governing Law and Dispute Resolution",
    content: [
      "These Terms are governed by and construed in accordance with the laws of India, specifically the Information Technology Act 2000, the Consumer Protection Act 2019, and other applicable statutes.",
      "Any disputes arising from or related to these Terms or your use of the Platform shall be subject to the exclusive jurisdiction of the courts in Gondia, Maharashtra, India.",
      "We encourage you to contact us first to resolve any disputes informally before initiating legal proceedings.",
    ],
  },
  {
    id: "contact",
    title: "Contact and Grievance Officer",
    content: [
      "For any questions, concerns, or grievances relating to these Terms or the Platform, please contact our Grievance Officer:",
      "Email: connect@kodevedic.com",
      "Address: KodeVedic / JoinSPAF, RICECITY, Near ZP School, Fulchur, Gondia, Maharashtra – 441601, India.",
      "We will acknowledge your grievance within 48 hours and endeavour to resolve it within 15 business days.",
    ],
  },
];

export default TermsData;
